<div *ngIf="show" class="celebration">
    <span *ngFor="let char of text.split('');trackBy: trackByFn">{{ char }}</span>
    <div class="confetti" *ngFor="let i of [].constructor(1200); trackBy: trackByFn"></div>
</div>
